import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';

const data = [
  {
    head: "Taxes",
    desc:"A Tax is deducted when you buy/sell/transfer. Taxes funds Operations, Liquidity Pools, Staking, Token Burns etc.The Tax Rates are set by Smart Contract and can be changed dynamically over time as the project develops."
  },
{
  head: "Operations & Marketing",
  desc:"Parts of the funds received from the Buy/Sell tax will fund operations and marketing. The exact rate is dynamic and is set by Smart Contract, and can be adjusted at any time"
},
{
  head: "Liquidity Pools",
  desc:"Parts of the funds received from the Buy/Sell tax will fund the Liquidity Pools, making the token more liquid and reducing slip fees. The exact rate is dynamic and is set by Smart Contract, and can be adjusted at any time"
},
{
  head: "Staking Rewards",
  desc:"Parts of the funds received from the Buy/Sell tax will go to $GODZ token holders who stake their tokens. The exact rate is dynamic and is set by Smart Contract, and can be adjusted at any time"
},
{
  head: "Token Burns",
  desc:"Parts of the funds received from the Buy/Sell/transfer taxes will go towards $GODZ token burns, creating a deflationary and scarce $GODZ token. The exact rate is dynamic and is set by Smart Contract, and can be adjusted at any time"
},
]

function Maincarousel() {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel  activeIndex={index} onSelect={handleSelect}>
       {data.map((slide, i) => {
        return (
          <Carousel.Item>        
            <div className='tax__carousel'>
                        <div className='tax__sub'>{slide.head}</div>
              <div className='tax__p'>
                {slide.desc}
              </div>
                          </div>
        {/* <Carousel.Caption>
          <p>{i}</p>
        </Carousel.Caption> */}
      </Carousel.Item>
        )
      })}
      
    </Carousel>
  );
}

export default Maincarousel